// extracted by mini-css-extract-plugin
export default {"pageTabs":"tx_tabs-module___pageTabs___e78af525","active":"tx_tabs-module___active___de5373c4","filtersButton":"tx_tabs-module___filtersButton___b8c7310e"};